export enum LightErrorState {
	NoError = 'NO_ERROR',
	ClearableError = 'CLEARABLE_ERROR',
	NonClearableError = 'NON_CLEARABLE_ERROR'
}
